import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "widget s20 px-6 py-7" }
const _hoisted_2 = { class: "s10 secondary-font text-grey-700 mb-4 text-right" }
const _hoisted_3 = { class: "s10 secondary-font text-red mb-4 text-right" }
const _hoisted_4 = { class: "s10 secondary-font text-grey-700 mb-4 text-right" }
const _hoisted_5 = { class: "s20 flex-center bg-color rounded-20 px-5 pt-4 pb-3" }
const _hoisted_6 = { class: "s10 secondary-font text-primary-color text-right" }


import { useMarketCartStore } from '@/stores/cart.store';
import { formatAmount } from '@/utils/formatters';


export default /*@__PURE__*/_defineComponent({
  __name: 'MarketCartInfos',
  props: {
    layout: { type: String, default: 'none' },
    hideButton: { type: Boolean, default: false },
},
  setup(__props) {

// @ts-expect-error raison: lib externe mal typée
const cart = useMarketCartStore();
const props = __props;


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "secondary-font text-grey-700 mb-5" }, "Votre commande", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "s10 secondary-font text-grey-700 mb-4" }, "Sous-total", -1)),
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(formatAmount)(_unref(cart).getSubTotal)) + " F", 1),
    _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "s10 secondary-font text-red mb-4" }, "Réduction", -1)),
    _createElementVNode("h5", _hoisted_3, "-" + _toDisplayString(_unref(formatAmount)(_unref(cart).getTotalReduction)) + " F", 1),
    _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "s10 secondary-font text-grey-700 mb-4" }, "TOTAL", -1)),
    _createElementVNode("h5", _hoisted_4, _toDisplayString(_unref(formatAmount)(_unref(cart).getTotal)) + " F", 1),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "clear-both h-0" }, null, -1)),
    _createElementVNode("div", _hoisted_5, [
      _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "s10 secondary-font text-primary-color" }, "Payer par mois", -1)),
      _createElementVNode("h5", _hoisted_6, _toDisplayString(_unref(formatAmount)(_unref(cart).getTotalEcheances)) + " F", 1)
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
    (!__props.hideButton)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: (__props.layout == 'frontoffice' ? '/front/market/checkout' : '/market/checkout')
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("button", { class: "btn-ultra lg w-100" }, [
              _createElementVNode("div", { class: "btn-show" }, [
                _createElementVNode("span", null, " Valider mon panier")
              ]),
              _createElementVNode("div", { class: "btn-loading" }, [
                _createElementVNode("div", { class: "loader-dots" })
              ])
            ], -1)
          ]))]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true)
  ]))
}
}

})